export default {
	"Coupon.Loading": "載入...",
	"Coupon.ClaimSuccessful": "領取成功",
	"Coupon.rise": "起",
	"Coupon.full": "滿",
	"Coupon.available": "可用",
	"Coupon.PickUpAgain": "再次領取",
	"Coupon.ClaimItNow": "立即領取",
	"Coupon.Preferential": "優惠",
	"Coupon.MoreCoupons": "更多優惠券"
}